export const devolution = {
	title: "Recargas expiradas",
	expired: "Expirado",
	toExpire: "A expirar",
	totalExpired: "Total de recargas expiradas",
	totalToExpire: "Total de recargas a expirar",
};
